import { addToOverviewList } from './changesOverview'
import { byKey } from '../functions'
import { handleSessionTimeout } from '../login'
import { rest } from '../server'
import { debug } from '../storage'
import { token } from '../tokens'

export let changes = [];
export const setChanges = (c) => changes = c;
export function getChanges() {
  return import('../../requests/layer_updates.json').then(sendingJson => {
    return $.ajax({
      type: 'POST',
      url: rest + '/layers_new_updates_request' + token,
      data: JSON.stringify(sendingJson.default),
      error: handleSessionTimeout,
      contentType: 'application/json',
      dataType: 'json'
    }).then(data => {
      // if (debug < 7) { console.log('Received JSON', data); }
      const c = data['layersNewUpdatesResLayers'];
      c.sort(byKey('id_after')).sort(byKeyWhenString('layer_id'));
      const tot = c.length;
      c.forEach( (item, index) => {
        // if (debug < 16) console.log(item, index);
        addToOverviewList(item, index + 1, tot);
      });
      return c;
    });
  });
}

let acceptUpdateJson = null; // cache it
export function acceptUpdate(rowIndex) {
  if (debug < 7) { console.log('accept row:', rowIndex); }
  const i = rowIndex - 1;
  if (!changes[i]) { return; }
  const id_after = changes[i]['id_after'];
  if (acceptUpdateJson) {
    accept(id_after);
  } else {
    import('../../requests/accept_update.json').then(sendingJson => {
      acceptUpdateJson = sendingJson.default;
      accept(id_after);
    });
  }
  // remove element from array
  changes[i] = null; // do not remove it to keep index order
  // remove row from table
  const t = document.getElementById('overviewBody');
  t.children[i].hidden = true; // do not remove it to keep index order
}
function accept(id) {
  acceptUpdateJson.data_update_log_id_after = id;
  $.ajax({
    type: 'POST',
    url: rest + '/layer_accept_update_request' + token,
    data: JSON.stringify(acceptUpdateJson),
    success: data => {
      // if (debug < 7) { console.log('Received JSON', data); }
    },
    error: e => { console.log('Kunne ikke godkjennes'); handleSessionTimeout(e); },
    contentType: 'application/json',
    dataType: 'json'
  });
}

let rejectUpdateJson = null; // cache it
export function rejectUpdate(rowIndex) {
  if (debug < 7) { console.log('reject row:', rowIndex); }
  const i = rowIndex - 1;
  if (!changes[i]) { return; }
  const id_before = changes[i]['id_before'];
  if (rejectUpdateJson) {
    reject(id_before);
  } else {
    import('../../requests/reject_update.json').then(sendingJson => {
      rejectUpdateJson = sendingJson.default;
      reject(id_before);
    });
  }
  // remove row from table
  const t = document.getElementById('overviewBody');
  t.children[i].hidden = true; // do not remove it to keep index order
  // show saksbehandler a message with contact of distrikt who made the change
  console.log('Ta kontakt med brukeren:', changes[i].saksbehandler_after);
  // remove element from array
  changes[i] = null; // do not remove it to keep index order
}
function reject(id) {
  rejectUpdateJson.data_update_log_id_before = id;
  $.ajax({
    type: 'POST',
    url: rest + '/layer_reject_update_request' + token,
    data: JSON.stringify(rejectUpdateJson),
    success: data => {
      // if (debug < 7) { console.log('Received JSON', data); }
    },
    error: e => { console.log('Kunne ikke nektes'); handleSessionTimeout(e); },
    contentType: 'application/json',
    dataType: 'json'
  });
}

// To sort an array of obj by obj.key, in case key value is a string
function byKeyWhenString(k) {
  return function (a, b) {
    return ((a[k] === b[k]) ? 0 : ((a[k] > b[k]) ? 1 : -1));
    // return a[k] > b[k];
  };
};
